import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function MoreVertical({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M11.9902 17.5C11.7102 17.5 11.4902 17.72 11.4902 18C11.4902 18.27 11.7102 18.5 11.9902 18.5C12.2602 18.5 12.4902 18.27 12.4902 18C12.4902 17.72 12.2602 17.5 11.9802 17.5M11.9902 11.5C11.7102 11.5 11.4902 11.72 11.4902 12C11.4902 12.27 11.7102 12.5 11.9902 12.5C12.2602 12.5 12.4902 12.27 12.4902 12C12.4902 11.72 12.2602 11.5 11.9802 11.5M11.9902 5.5C11.7102 5.5 11.4902 5.72 11.4902 6C11.4902 6.27 11.7102 6.5 11.9902 6.5C12.2602 6.5 12.4902 6.27 12.4902 6C12.4902 5.72 12.2602 5.5 11.9802 5.5" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default MoreVertical;